import React from 'react';
import Image from 'react-bootstrap/Image';
import { Col, Container, Row } from 'react-bootstrap';
import "../../assets/scss/project/project-showcase-raster.scss"

import BrowserTop from './BrowserTop';
import IShowCaseTypes from '../../models/IShowCaseTypes';
import ProjectShowcaseRasterRow from './ProjectShowcaseRasterRow';
import { IImage } from '../../models/IScreen';
import { LazyLoadComponent } from 'react-lazy-load-image-component';

interface IProps extends IRaster {
    bgColor: string;
}

export interface IRaster {
    items: IImage[];
}

function ProjectShowCaseRaster(props: IProps) {
    // 6
    const maxImagesInRow = 4;
    const length = props.items.length;
    const rowAmount = Math.ceil(length / 4);

    const imagesPerRow = length / rowAmount;

    let array = [];
    for (let i = 0; i < rowAmount; i++) {
        array.push(props.items.slice(i * imagesPerRow, (i + 1) * imagesPerRow))
    }





    const showcase = array.map((singleRow: any, index: number) => {

        return <ProjectShowcaseRasterRow key={index} items={singleRow} />;

    });


    const populateImages = (images: IImage[]): JSX.Element[] => {
        const items = images.map((image: IImage, index: number) => {
            return <Image key={index} className="showcase-raster" src={image.src} alt={image.alt} />
        })
        return items;
    }





    return (
        <Container>
            <Row>
                <Col>
                    <Container fluid className="show-case-raster" style={{ backgroundColor: props.bgColor }}  >
                        <LazyLoadComponent threshold={500}>
                            {showcase}
                        </LazyLoadComponent>
                    </Container>
                </Col>
            </Row>
        </Container>
    );
}

export default ProjectShowCaseRaster;